import React from "react";

const ProjectDetails = ({ empFormData, setEmpFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEmpFormData("projectDetails", {
      [name]: value,
    });
  };

  return (
    <>
      <div className="form-section">
        <h3>Project Details</h3>
        <div className="form-group">
          <label className="required">Name of the Project</label>
          <input
            type="text"
            name="projectName"
            value={empFormData.projectDetails.projectName}
            onChange={handleInputChange}
            placeholder="Enter Project Name"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">City/Village/Town</label>
          <input
            type="text"
            name="villageName"
            value={empFormData.projectDetails.villageName}
            onChange={handleInputChange}
            placeholder="Enter City/Village/Town"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Tehsil</label>
          <input
            type="text"
            name="projectTehsil"
            value={empFormData.projectDetails.projectTehsil}
            onChange={handleInputChange}
            placeholder="Enter Tehsil"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">District</label>
          <input
            type="text"
            name="projectDistrict"
            value={empFormData.projectDetails.projectDistrict}
            onChange={handleInputChange}
            placeholder="Enter District"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Project Area (in hectares)</label>
          <input
            type="number"
            name="projectArea"
            value={empFormData.projectDetails.projectArea}
            onChange={handleInputChange}
            placeholder="Enter Project Area"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Khasra No.</label>
          <input
            type="text"
            name="projectKhasraNo"
            value={empFormData.projectDetails.projectKhasraNo}
            onChange={handleInputChange}
            placeholder="Enter Khasra Number"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Production Capacity</label>
          <input
            type="text"
            name="projectProductionCapacity"
            value={empFormData.projectDetails.projectProductionCapacity}
            onChange={handleInputChange}
            placeholder="Enter Production Capacity"
            required
          />
        </div>
      </div>
      <div className="form-section">
        <h3>Applicant Details</h3>
        <div className="form-group">
          <label className="required">Name of Applicant</label>
          <input
            type="text"
            name="applicantName"
            value={empFormData.projectDetails.applicantName}
            onChange={handleInputChange}
            placeholder="Enter Applicant Name"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Address of Applicant</label>
          <textarea
            name="applicantAddress"
            value={empFormData.projectDetails.applicantAddress}
            onChange={handleInputChange}
            placeholder="Enter Applicant Address"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Email of Applicant</label>
          <input
            type="email"
            name="applicantEmail"
            value={empFormData.projectDetails.applicantEmail}
            onChange={handleInputChange}
            placeholder="Enter Applicant Email"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Mobile of Applicant</label>
          <input
            type="text"
            name="applicantMobile"
            value={empFormData.projectDetails.applicantMobile}
            onChange={handleInputChange}
            placeholder="Enter Applicant Mobile"
            required
          />
        </div>
      </div>
    </>
  );
};

export default ProjectDetails;
